import Alert from "../alert";
import { useState } from "react";

function AddUserModal({ showAdduser, handleClose }) {
    const [viewAlert, setViewAlert] = useState(false);
    const [f_name, setFName] = useState('');
    const [l_name, setLName] = useState('');
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [address, setAddress] = useState('');
    const [role, setRole] = useState('');
    const [profile, setProfile] = useState('');
    const [loading, setLoading] = useState(false);
    const [formError, setFormError] = useState(null);
    const defaultStatus = "Active";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setFormError(null);

        const token = localStorage.getItem('token');
        console.log('Token:', token);
        if (!token) {
            setFormError("No authentication token found.");
            setLoading(false);
            return;
        }

        const payload = {
            f_name,
            l_name,
            username,
            email,
            status: defaultStatus,
            password,
            role,
            u_address: address,
            u_profile: profile || null
        };

        console.log('Payload:', payload);

        try {
            console.log('Sending request to:', 'https://api.magsayo.net/api/add_user');
            const res = await fetch('https://api.magsayo.net/api/add_user', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            console.log('Response status:', res.status);
            console.log('Response headers:', res.headers);

            const responseText = await res.text();
            console.log('Response text:', responseText);
            let responseData = null;
            try {
                responseData = JSON.parse(responseText);
                console.log('Parsed response:', responseData);
            } catch {
                console.log('Response is not JSON');
                responseData = responseText;
            }

            if (!res.ok) {
                const message = responseData?.message || responseData?.error || responseData || `Failed to add user: ${res.status}`;
                console.error('Error message:', message);
                throw new Error(message);
            }

            console.log('User added successfully:', responseData);
            setViewAlert(true);
            handleClose();
            setFName('');
            setLName('');
            setUsername('');
            setEmail('');
            setPassword('');
            setAddress('');
            setRole('');
            setProfile('');
        } catch (error) {
            console.error("Error adding user:", error);
            setFormError(error.message || "Failed to add user. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>


            {/* Alert */}
            <Alert
                show={viewAlert}
                message="User added successfully!"
                type="success"
                onClose={() => setViewAlert(false)}
            />
            <div
                className={`modal fade ${showAdduser ? "show d-block" : ""}`}
                tabIndex="-1"
                style={{ backgroundColor: showAdduser ? "rgba(0,0,0,0.5)" : "transparent" }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title"><strong>Add User</strong></h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>

                        <div className="modal-body">
                            <form className="row g-3" onSubmit={handleSubmit}>
                                <div className="col-md-6">
                                    <input type="text" className="form-control" placeholder="First Name" value={f_name} onChange={(e) => setFName(e.target.value)} required />
                                </div>
                                <div className="col-md-6">
                                    <input type="text" className="form-control" placeholder="Last Name" value={l_name} onChange={(e) => setLName(e.target.value)} required />
                                </div>
                                <div className="col-12">
                                    <input type="text" className="form-control" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required />
                                </div>
                                <div className="col-md-6">
                                    <input type="email" className="form-control" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                </div>
                                <div className="col-md-6">
                                    <input type="password" className="form-control" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                </div>
                                <div className="col-12">
                                    <input type="text" className="form-control" placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)} required />
                                </div>
                                <div className="col-md-6">
                                    <input type="file" className="form-control" onChange={(e) => setProfile(e.target.files?.[0]?.name || '')} />
                                </div>
                                <div className="col-md-6">
                                    <select id="inputState" className="form-select" value={role} onChange={(e) => setRole(e.target.value)} required>
                                        <option value="">Choose Role</option>
                                        <option value="Master Admin">Master Admin</option>
                                        <option value="Full Admin">Full Admin</option>
                                        <option value="Temporary Admin">Temporary Admin</option>
                                    </select>
                                </div>

                                {formError && (
                                    <div className="col-12">
                                        <div className="alert alert-danger mb-0" role="alert">
                                            {formError}
                                        </div>
                                    </div>
                                )}

                                <div className="col-12 modal-footer px-0">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleClose}
                                        disabled={loading}
                                    >
                                        Close
                                    </button>

                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading ? 'Saving...' : 'Save User'}
                                    </button>
                                </div>
                            </form>
                            {/* <!-- End No Labels Form --> */}
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default AddUserModal;